"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _cuid = _interopRequireDefault(require("cuid"));

var DoubleArrowDown = function DoubleArrowDown(props) {
  var uniqueId = (0, _cuid["default"])();
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({}, props, {
    uniqueId: uniqueId,
    iconName: "DoubleArrowDown"
  }), /*#__PURE__*/_react["default"].createElement("title", null, "Artboard 809"), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.1,9.62a1.26,1.26,0,0,0,1.76,0l7.27-7.23A1.25,1.25,0,0,0,16.37.61L10,7,3.63.62A1.25,1.25,0,0,0,1.86,2.38Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.37,10.37,10,16.72,3.63,10.37a1.24,1.24,0,1,0-1.76,1.76l7.25,7.24a1.26,1.26,0,0,0,1.76,0l7.25-7.24a1.24,1.24,0,0,0-1.76-1.76Z"
  }));
};

var _default = DoubleArrowDown;
exports["default"] = _default;